import moment from "moment";

export function isValidateParoleEligibilityDate(dateString: string) {
  // Check if the date string matches the MM/DD/YYYY format
  return moment(dateString, "MM/DD/YYYY", true).isValid();
}
